import extractScripts from "@/utils/extract-scripts";
import { decode } from "html-entities";
import { baseUrl } from "@/utils/api-definition";
import Script from "next/script";
import { v4 as uuidv4 } from "uuid";
import React from "react";
import { Trans } from "@lingui/react/macro";
import Link from "@/components/core/localized-link";
import ImageWithFallback from "@/components/core/image-with-fallback";
import Image from "next/image";
import { coerceLocale, localizeHtmlAnchors } from "@/utils/localize-path";

function replaceAll(str: string, find: string, replace: string) {
  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
}
function escapeRegExp(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

export const filterLayouts = (sections: any[]) =>
  sections
    .map((layout) => ({
      isList: layout.type === "cms" || layout.type === "category",
      content: layout,
    }))
    .filter((item) => item.content);

export const handleNonListHTML = (customHTML: any, section_name?: string, lang?: string) => {
  const { html, scripts } = extractScripts(customHTML);
  let customHtml = decode(html);
  customHtml = replaceAll(customHtml, ' src="/', ' src="' + baseUrl + "/");
  customHtml = localizeHtmlAnchors(customHtml, coerceLocale(lang));
  return (
    customHtml && (
      <div
        key={uuidv4()}
        className={`${section_name === "TVArea" ? "" : "cms-container"} md:mt-[50px]`}
      >
        {scripts.map((script: any) => {
          if (script.src) {
            return (
              <Script src={script.src} id={uuidv4()} key={uuidv4()} strategy="beforeInteractive" />
            );
          } else {
            return (
              <Script id={uuidv4()} key={uuidv4()} strategy="afterInteractive">
                {script.content}
              </Script>
            );
          }
        })}
        <div
          dangerouslySetInnerHTML={{
            __html: customHtml,
          }}
        ></div>
      </div>
    )
  );
};
export const handleListHTML = (customHTML: any) => {
  return (
    <div key={uuidv4()} className="md:mt-[50px]">
      <p className="mb-5 text-xl font-semibold md:text-[25px]">
        <Trans>{customHTML.section_name}</Trans>
      </p>
      <div className="mb-8 flex flex-wrap gap-x-7 gap-y-5">
        {customHTML.items &&
          Object.values(customHTML.items).map((layoutItem: any, itemIndex: number) => (
            <Link
              key={itemIndex}
              data-testid={`${layoutItem.type}-${layoutItem.seo_url ? layoutItem.seo_url : layoutItem.link}-link`}
              href={`/${layoutItem.type}/${layoutItem.seo_url ? layoutItem.seo_url : layoutItem.link}`}
            >
              <div className="flex h-[220px] w-[180px] cursor-pointer flex-col items-start justify-start rounded-[15px] text-black shadow-[0_5px_18px_0_rgba(40,43,47,0.2)] hover:shadow-[0_7px_19px_0_rgba(40,43,47,0.32)] md:h-[252px] md:w-[210px]">
                <ImageWithFallback src={layoutItem.image} alt="" width={210} height={140} />
                <div className="px-5 pb-2 md:px-[25px]">
                  <p className="mb-2.5 text-[17px] font-bold duration-300 ease-in hover:text-[#0097ab] md:mb-[15px] md:text-lg">
                    {layoutItem.title}
                  </p>
                  <p className="text-[17px] opacity-[80%] md:text-lg">{layoutItem.subtitle}</p>
                </div>
              </div>
            </Link>
          ))}
      </div>
    </div>
  );
};

export const handleSlideshow = (customHTML: any) => {
  if (!customHTML?.items) return null;

  return customHTML.items.map((item: any, index: number) => (
    <div
      key={index}
      className="container mt-[80px] flex flex-col-reverse gap-5 md:mt-8 md:flex-row"
    >
      <div className="flex w-full flex-col justify-center px-3 md:w-1/2">
        <p className="mb-5 text-[32px] font-bold leading-[1.1] md:text-[35px] lg:text-[50px]">
          {item.h2_content[0]}
        </p>
        <p className="text-lg font-medium leading-[1.07] opacity-80 md:text-xl">
          {item.p_content.map((content: string) =>
            content === "<br>" ? (
              <>
                <br />
                <br />
              </>
            ) : (
              decode(content)
            ),
          )}
        </p>
      </div>
      <div className="w-full md:w-1/2">
        {/* <Link prefetch={false} href={item.link}> */}
        <Image
          loading="lazy"
          src={item.image}
          alt={item.title}
          width={750}
          height={446}
          className="h-full max-h-[450px] w-full rounded-[16px] object-cover"
        />
        {/* </Link> */}
      </div>
    </div>
  ));
};

export const stickCustomHTML = (customHTML: any, lang?: string) => {
  if (customHTML.content?.type === "slideshow") {
    return handleSlideshow(customHTML.content);
  } else if (customHTML.isList) {
    return handleListHTML(customHTML.content);
  } else {
    return handleNonListHTML(decode(customHTML.content?.content?.description), undefined, lang);
  }
};
